const routes = {
  path: '/data-center',
  component: () => import('@/components/layout/index.vue'), 
  alwaysShow: true,
  meta: {
    title: '数据中心',
    icon: 'iconshujuzhongxin',
    permission: 'report'
  },
  children: [
    {
      path: 'report/sale',
      name: 'SaleStatement',
      component: () => import('@/views/statement/sale'),
      meta: {
        title: '数据概览',
        permission: 'report.collision'
      }
    },
    {
      path: 'report/funnel',
      name: 'FunnelStatement',
      component: () => import('@/views/statement/funnel'),
      meta: {
        title: '销售漏斗',
        permission: 'report.sale'
      }
    },
    {
      path: 'report/sales-list',
      name: 'SaleListStatement',
      component: () => import('@/views/statement/salesList'),
      meta: {
        title: '销售榜单',
        permission: 'report.sale-ranking'
      }
    },
    {
      path: 'report/follow',
      name: 'FollowStatement',
      component: () => import('@/views/statement/follow'),
      hidden: true,
      meta: {
        title: '跟进情况',
        permission: 'report.first_follow'
      }
    },
    {
      path: 'report/waiting-list',
      name: 'WaitingDoReport',
      component: () => import('@/views/statement/waitingDo'),
      meta: {
        title: '待办统计',
        permission: 'report.task.common'
      }
    },
    {
      path: 'report/call-analysis',
      name: 'callAnalysis',
      component: () => import('@/views/statement/callAnalysis'),
      meta: {
        title: '400分析',
        permission: 'report.call'
      }
    },
    {
      path: 'report/customer-analysis',
      name: 'customerAnalysis',
      component: () => import('@/views/statement/customerAnalysis'),
      meta: {
        title: '客户分析',
        permission: 'report.customer'
      }
    },
    {
      path: 'report/im-analysis',
      name: 'imAnalysis',
      component: () => import('@/views/statement/IMAnalysis'),
      meta: {
        title: 'IM分析',
        permission: 'report.im'
      }
    },
    {
      path: 'report/user-analysis',
      name: 'UserAnalysis',
      component: () => import('@/views/statement/userAnalysis'),
      meta: {
        title: '员工分析',
        permission: 'report.operate'
      }
    },
    {
      path: 'report/put-manager-list',
      name: 'PutDataAnalysis',
      component: () => import('@/views/statement/putManager/index'),
      meta: {
        title: '投放数据',
        permission: 'report.sem'
      }
    }
  ]
}
export default routes;